import chinese from './zh'
import english from './en'

export default {
  chinese,
  english
}


// WEBPACK FOOTER //
// ./src/international/locale.js